import { useUserStore } from '@/store/app'
import pinia from '@/plugins'
import authService from '@/request/api/auth'
import '@/libs/watermark-sdk'

// 控制路由切换时不再重复请求，并且保证路由切换时一定取得了权限信息
let asyncDataLoaded = false

/**
 *
 * @param {*} routes 本地定义的全部路由信息
 * @returns
 */
const useAuthentication = async (routes) => {
  const store = useUserStore(pinia)

  const SYSCODE = 'mercedes_community'

  //   获取menu
  const getMenu = (subSystems) => {
    const systemInfo = subSystems.filter((item) => item.code === SYSCODE)

    let menuPermissions = []
    if (systemInfo && systemInfo.length) {
      menuPermissions = systemInfo[0].menus
    }
    return menuPermissions
  }

  //   获取community权限信息
  const getCommunitySystemInfo = (subSystems) => {
    const systemInfo = subSystems.filter((item) => item.code === SYSCODE)

    if (systemInfo.length) {
      return systemInfo[0]
    }
    return {
      basePath: '/',
      code: SYSCODE,
      name: '',
    }
  }

  // 本地开发时模拟菜单和按钮
  const loadMockSystemState = (systemCode) => {
    const categories = [
      { code: 'MercedesCommunity', name: 'MEC' },
      { code: 'test5', name: 'test5' },
    ]
    const menus = [
      {
        code: 'DASHBOARD',
        name: 'Operation Figure',
      },
      {
        code: 'CAMPAIGN',
        name: 'Campaign Mgmt',
      },
      {
        code: 'CAMPAIGNLIST',
        name: 'Campaign List',
      },
      {
        code: 'CAMPAIGNDETAIL',
        name: 'Campaign Detail',
      },
      {
        code: 'NEWCAMPAIGN',
        name: 'New Campaign',
      },
      {
        code: 'EDITCAMPAIGN',
        name: 'Edit Campaign',
      },
      {
        code: 'LOTTERYLIST',
        name: 'LotteryList',
      },
      {
        code: 'LOTTERYINFO',
        name: 'Lottery Info',
      },
      {
        code: 'USERMGMT',
        name: 'User Mgmt',
      },
      {
        code: 'USERLIST',
        name: 'User List',
      },
      {
        code: 'USERDETAIL',
        name: 'User Detail',
      },
      {
        code: 'DUMMYUSER',
        name: 'Dummy User',
      },
      {
        code: 'DUMMYDETAIL',
        name: 'Dummy Detail',
      },
      {
        code: 'FORUM',
        name: 'Forum Mgmt',
      },
      {
        code: 'PGCLIST',
        name: 'PGC List',
      },
      {
        code: 'PGCDETAIL',
        name: 'PGC Detail',
      },
      {
        code: 'NEWPGC',
        name: 'New PGC',
      },
      {
        code: 'EDITPGC',
        name: 'Edit PGC',
      },
      {
        code: 'UGCLIST',
        name: 'UGC List',
      },
      {
        code: 'UGCDETAIL',
        name: 'UGC Detail',
      },
      {
        code: 'TOPICLIST',
        name: 'Topic List',
      },
      {
        code: 'TOPICINFO',
        name: 'Topic Info',
      },
      {
        code: 'POSTSREPORT',
        name: 'Reported Posts',
      },
      {
        code: 'REPORTDETAIL',
        name: 'Report Detail',
      },
      {
        code: 'TRIBE',
        name: 'Tribe Mgmt',
      },
      {
        code: 'TRIBELIST',
        name: 'Tribe List',
      },
      {
        code: 'TRIBEDETAIL',
        name: 'Tribe Detail',
      },
      {
        code: 'COMMON',
        name: 'Common Interface',
      },
      {
        code: 'STATISTIC',
        name: 'Statistics Mgmt',
      },
      {
        code: 'STATISTIC',
        name: 'Statistics Mgmt',
      },
      { code: 'NOTIFICATIONLIST', name: 'Notification List' },
      { code: 'VIOLATIONLIST', name: 'ViolationList' },
      { code: 'VIOLATIONHANDLELIST', name: 'ViolationHandleList' },
      { code: 'MEC_TAG', name: 'Tag Mgmt.' },
      { code: 'COMMENTLIST', name: 'Comment List' },
    ]
    const buttons = [
      { code: 'CAMPAIGN_EDIT', name: '编辑权限' },
      { code: 'LOTTERY_EDIT', name: '奖池编辑权限' },
      { code: 'PGC_EDIT', name: '编辑权限' },
      { code: 'TRIBE_EDIT', name: '编辑权限' },
    ]
    const buttonPermissions = buttons.map(({ code }) => code)

    return {
      user: {
        wiwId: 'mocker',
        email: 'mocker@gmail.com',
        username: 'mocker',
        isSystemAdmin: true,
      },
      systemInfo: {
        basePath: '/',
        code: systemCode,
        name: 'Mock System',
      },
      categories,
      menus,
      buttons,
      buttonPermissions,
      menuItems: [],
      token: '',
    }
  }

  // 接口获取菜单和按钮权限等系统信息
  const loadSystemState = async () => {
    // 获取信息（mock或者真实接口-依据环境判定）
    const {
      systemInfo: {
        application,
        category,
        subSystems,
        wiwId,
        familyName,
        givenName,
        email,
        isSystemAdmin,
      },
      token,
      watermarkInfo,
    } = await authService.getSystemInfo()
    console.log('application:', application)
    const username =
      familyName && givenName
        ? `${familyName} ${givenName}`
        : familyName ?? givenName

    // 构建用户信息
    const user = { wiwId, email, username, isSystemAdmin }

    const { basePath, code, name } = getCommunitySystemInfo(subSystems)

    const menuItems = getMenu(subSystems)
    // // 构建系统信息
    const systemInfo = { basePath, code, name }

    // 构建按钮信息
    const buttons =
      menuItems?.flatMap(
        (menu) =>
          menu.buttons?.map((btn) => ({ code: btn.code, name: btn.name })) ?? []
      ) ?? []
    //  subSystems
    const currentSystem = subSystems?.find((item) => item.code === SYSCODE)

    if (!currentSystem) {
      throw new Error('Server error')
    }
    // // 菜单排序处理
    const menus =
      currentSystem.menus
        ?.sort((a, b) => a.sortIndex - b.sortIndex)
        ?.map((item) => ({ code: item.code, name: item.name })) ?? []
    //  分类排序处理
    const categories = [category]
    // 按钮权限
    const buttonPermissions =
      currentSystem.menus?.flatMap(
        (item) => item.buttons?.map((itemX) => itemX.code) ?? []
      ) ?? []

    return {
      user,
      systemInfo,
      categories,
      menus,
      buttons,
      buttonPermissions,
      menuItems,
      token,
      watermarkInfo,
    }
  }

  if (asyncDataLoaded) return
  // 获取系统状态
  const getSystemState = async () => {
    // 想在本地开发而不加载系统菜单和按钮 配置为 1
    if (import.meta.env.VITE_APP_MOCK_SYSTEM === '1') {
      // eslint-disable-next-line no-return-await
      return await loadMockSystemState()
    }
    // eslint-disable-next-line no-return-await
    return await loadSystemState()
  }

  try {
    store.updateLoadStatus('LOADING')

    const { user, menus, buttonPermissions, token, watermarkInfo } =
      await getSystemState()

    const sysInfo = {
      menuPermissions: menus,
      buttonPermissions,
      user,
      token,
    }

    asyncDataLoaded = true
    // 更新用户权限信息
    store.updateUserInfo(sysInfo)
    // 更新菜单权限
    store.filterMenu(routes)

    store.updateLoadStatus('SUCCEEDED')

    // 初始化水印
    try {
      // eslint-disable-next-line no-undef
      watermark.init({
        host: '/watermark',
        objectId: watermarkInfo.objectId,
        username: watermarkInfo.username,
        secret: watermarkInfo.secret,
        wmOpacity: 3,
        lbOpacity: 3,
      })
    } catch (error) {
      console.error('watermark init failed:', error)
    }
  } catch (error) {
    if (error?.message?.includes('401')) {
      store.updateLoadStatus('EXPIRES')
    } else {
      store.updateLoadStatus('FAILED')
    }
  }
  // }
}
export default useAuthentication
